const isProd = window.location.host==='partner.ximalaya.com' 
const baseHost = !isProd ? '.test' : ''

const config = {
  state: {
    FILE_UPLOAD_PATH: `\/\/upload${baseHost}.ximalaya.com/dtres/picture/upload`,
    FILE_UPLOAD_TOEKN: isProd ? '1&_token':'4&_token',
    SUBSITE_HOST: `subsite${baseHost}.ximalaya.com`,
    SUB_PREVIEW_ID: isProd ? 1 : 199,
    PROTOCOL: (("https:" == document.location.protocol) ? "https://" : "http://"),
    HOST: `partner${!isProd ? '.test':''}.ximalaya.com`,
    AVATAR_LINK: `${isProd?'www':'test'}.ximalaya.com/zhubo/`
  },
  mutations: {
    
  },
  actions: {

  }
};

export default config;


// WEBPACK FOOTER //
// ./src/store/modules/config.js